import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const HR = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="hr"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.9024 14.4529C21.1062 15.1207 20.0804 15.5234 18.9624 15.5234C18.5897 15.5234 18.2273 15.4784 17.8801 15.394C18.093 15.9618 18.2097 16.5762 18.2097 17.2175V17.845C18.2097 18.6666 17.9098 19.4189 17.4146 20H20.8452C22.0335 20 23.0002 19.0333 23.0002 17.845V17.2175C23.0002 16.1488 22.5827 15.1759 21.9024 14.4529Z" fill="#009BB3"/>
      <path d="M13 14.3516C14.8804 14.3516 16.4101 12.8218 16.4101 10.9414C16.4101 9.06102 14.8804 7.53125 13 7.53125C11.1196 7.53125 9.58984 9.06102 9.58984 10.9414C9.58984 12.8218 11.1197 14.3516 13 14.3516Z" fill="#009BB3"/>
      <path d="M18.9622 14.3516C20.8427 14.3516 22.3724 12.8218 22.3724 10.9414C22.3724 9.06102 20.8427 7.53125 18.9622 7.53125C18.1264 7.53125 17.3599 7.83375 16.7661 8.33477C17.2802 9.07524 17.582 9.97368 17.582 10.9414C17.582 11.9091 17.2802 12.8075 16.7661 13.548C17.3599 14.0491 18.1263 14.3516 18.9622 14.3516Z" fill="#009BB3"/>
      <path d="M7.03756 14.3515C7.8735 14.3515 8.63994 14.049 9.23373 13.548C8.71963 12.8075 8.41779 11.9091 8.41779 10.9414C8.41779 9.97367 8.71963 9.07523 9.23373 8.33477C8.63998 7.83375 7.87354 7.53125 7.03756 7.53125C5.15721 7.53125 3.62744 9.06102 3.62744 10.9414C3.62744 12.8218 5.15725 14.3515 7.03756 14.3515Z" fill="#009BB3"/>
      <path d="M13.0002 15.5234C11.8821 15.5234 10.8564 15.1207 10.0601 14.4529C9.3799 15.1759 8.9624 16.1488 8.9624 17.2175V17.845C8.9624 19.0333 9.92912 20 11.1173 20H14.8829C16.0712 20 17.0379 19.0333 17.0379 17.845V17.2175C17.0379 16.1488 16.6204 15.1758 15.9401 14.4529C15.1439 15.1207 14.1183 15.5234 13.0002 15.5234Z" fill="#009BB3"/>
      <path d="M7.79035 17.2175C7.79035 16.5762 7.90711 15.9618 8.11996 15.394C7.77281 15.4784 7.41047 15.5234 7.0377 15.5234C5.91961 15.5234 4.89398 15.1207 4.0977 14.4529C3.4175 15.1758 3 16.1487 3 17.2175V17.845C3 19.0333 3.96668 20 5.15492 20H8.58563C8.09031 19.4189 7.79035 18.6666 7.79035 17.845V17.2175Z" fill="#009BB3"/>
    </svg>
  );
};
/* eslint-enable max-len */

HR.defaultProps = {
  className: null,
};

HR.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default HR;
